import React from "react";
import {
    Page,
    Text,
    View,
    Document,
    StyleSheet,
    Image
} from "@react-pdf/renderer";
import numeral from "numeral";
import logo from '../../assets/fonts/jc-logo.png';



const styles = StyleSheet.create({
  body: {
    paddingTop: 65,
    paddingBottom: 65,
    paddingHorizontal: 20,
    fontFamily:'Helvetica',
  },
  box: {
      display:'flex',
      flexDirection: 'row',
      justifyContent:'flex-start',
      marginTop:'45',
  },
  leftPart: {
    	minWidth:'50%',
      maxWidth:'50%',
  },
  rightPart: {
    	minWidth:'50%',
      maxWidth:'50%',
    	marginLeft:'5'
  },
  tblTitle : {
    fontSize:'9',
    marginBottom: '15',
    fontFamily:'Helvetica-Bold',
  },
  itemTitle : {
    fontSize:'9',
    marginTop: '25',
    fontFamily:'Helvetica-Bold',
  },
  itemTblHeader:{
      marginTop: '15',
      fontSize: '17'
  },
  
  tableItems:{
      display:'flex',
      flexDirection: 'row',   
      borderBottom: '1',
      paddingBottom: '4',
  },
  header1: {
    	minWidth:'85%',
      maxWidth:'85%',
      fontSize: '8',
      fontFamily:'Helvetica-Bold',
  },header2: {
    	minWidth:'15%',
      maxWidth:'15%',
      fontSize: '8',
      fontFamily:'Helvetica-Bold',
  },
  item1: {
    	minWidth:'65%',
      maxWidth:'65%',
      fontSize: '7',
  },
  item2: {
    fontSize: '7',
  },
  rightAlign:{
    minWidth:'35%',
    maxWidth:'35%',
    paddingRight:'60',
    alignItems:'flex-end',
  },
  paymentInfo: {
        display: 'flex',
        flexDirection: 'row',
      	justifyContent:'flex-start',
    	marginBottom: '5',
  },
  
  
  
  
  innerBox: {
      fontSize:'12',
      display:'flex',
      flexDirection: 'row',
      justifyContent:'flex-start',
      marginBottom: '5',
  },
  innerLeftPart: {
    	minWidth:'50%',
      maxWidth:'50%',
      alignItems:'flex-start',
      fontSize:'8',
  },
  innerRightPart: {
    	minWidth:'40%',
      alignItems:'flex-end',
      fontSize:'8',
  },
  innerLeftPart2: {
    minWidth:'100%',
    maxWidth:'100%',
    alignItems:'flex-start',
  },
  innerRightPart2: {
    minWidth:'100%',
    maxWidth:'100%',
    alignItems:'flex-start',
    fontSize:'8',
  },
  innerLeftPayment: {
    	minWidth:'50%',
      maxWidth:'50%',
      alignItems:'flex-start',
      fontSize:'8',
  },
  approvedBy: {
    	  minWidth:'80%',
        maxWidth:'80%',
        alignItems:'flex-start',
      	borderTop: '1',
        marginTop: '50',
        marginLeft: '175',
  },
  approver:{
    fontSize:'9',
    fontFamily:'Helvetica-Bold',
  },
  nestedItem1:{
    paddingLeft:'30'
  },
  nestedItem2:{
    paddingLeft:'21'
  },
  right:{
    alignSelf:'flex-end'
  },
  wrap:{
     marginBottom: '5',
  }, 
  mRight:{
     paddingLeft:'25',
  },
  title: {
    fontSize:'11',
    textAlign: 'center',
    fontFamily:'Helvetica-Bold',
  },
  author: {
    fontSize: 12,
    textAlign: 'center',
    marginBottom: '40',
  },
  subtitle: {
    fontSize: '18',
    margin: '12',
    fontFamily: 'Oswald',
  },
  text: {
    margin: '12',
    fontSize: '14',
    textAlign: 'justify',
    fontFamily: 'Times-Roman',
  },
  image: {
    position: 'absolute',
    width:'40px',
    height:'40px',
    left:19,
    top:45,
  },
  header: {
    fontSize: 12,
    marginBottom: 20,
    textAlign: 'center',
    color: 'grey',
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 9,
    bottom: 30,
    left: -500,
    right: 0,
    textAlign: 'center',
    color: 'grey',
  },
  totalTextBold:{
    fontSize:'8',
    // paddingLeft:'10',
    fontFamily:'Helvetica-Bold',
  },
  bold:{
    fontSize:'8',
    fontFamily:'Helvetica-Bold',
  }
});

  export function JcPortalUpgradeAccountPdf(props) {
    const {soInfo, items} = props;
      return (
        <Document>
        <Page size="A4" style={styles.body}>
          <Text style={styles.title}>JC PORTAL - UPGRADE ACCOUNT</Text>
          <Image
              style={styles.image}
              src={logo}
          />
            <View style={styles.box}>
              <View style={styles.leftPart}>
                <Text style={styles.tblTitle}>Order Information</Text>
                  <View style={styles.innerBox}>
                      <View style={styles.innerLeftPart}><Text>IDNO</Text></View>
                      <View style={styles.innerRightPart}><Text style={styles.right}>{soInfo.idno_to_load}</Text></View>
                   </View>
                    <View style={styles.innerBox}>
                      <View style={styles.innerLeftPart}><Text>Transaction Type</Text></View>
                      <View style={styles.innerRightPart}><Text style={styles.right}>Package Sales</Text></View>
                   </View>
                    <View style={styles.innerBox}>
                      <View style={styles.innerLeftPart}><Text>Transaction Date</Text></View> 
                      <View style={styles.innerRightPart}><Text style={styles.right}>{soInfo.transdate}</Text></View>
                   </View>
                    <View style={styles.innerBox}>
                      <View style={styles.innerLeftPart}><Text style={styles.nestedItem1}>Package Amount</Text></View>
                      <View style={styles.innerRightPart}><Text style={styles.right}>{numeral(soInfo.package_amount).format('0,0.00')}</Text></View>
                   </View>
                   <View style={styles.innerBox}>
                      <View style={styles.innerLeftPart}><Text style={styles.nestedItem2}>Shipping Fee</Text></View>
                      <View style={styles.innerRightPart}><Text style={styles.right}>{numeral(soInfo.shipping_fee).format('0,0.00')}</Text></View>
                   </View>
                    <View style={styles.innerBox}>
                      <View style={styles.innerLeftPart}><Text>Grand Total</Text></View>
                      <View style={styles.innerRightPart}><Text style={styles.right}>{numeral(soInfo.grand_total).format('0,0.00')}</Text></View>
                   </View>
               </View>
              
              <View style={styles.rightPart}>
                   <Text style={styles.tblTitle}>Delivery Details</Text>
                    <View style={styles.innerBox}>
                        <View style={styles.innerLeftPart}><Text>{soInfo.delivered_to}</Text></View>
                     </View>
                            <View style={styles.innerBox}>
                        <View style={styles.innerLeftPart}><Text>{soInfo.phone_number}</Text></View>
                     </View>
                        <View style={styles.innerBox}>
                        <View style={styles.innerLeftPart}><Text>{soInfo.email}</Text></View>
                     </View>
                       <View style={styles.innerBox}>
                        <View style={styles.innerLeftPart}><Text>{soInfo.waybill_no}</Text></View>
                     </View>
                        <View style={styles.innerBox}>
                        <View style={styles.innerLeftPart}><Text>Shipping Status</Text></View>
                            <View style={styles.innerRightPart}><Text style={styles.mRight}>{soInfo.isdelivered}</Text></View>
                     </View>
                        <View style={styles.innerBox}>
                        <View style={styles.innerLeftPart}><Text>Waybill No</Text></View>
                            <View style={styles.innerRightPart}><Text style={styles.mRight}>{soInfo.waybill_no}</Text></View>
                     </View>
               </View>
             </View>
          
            <View>
                <Text style={styles.itemTitle}>Upgrade Package Inclusion</Text>
            </View>
          
             <View style={styles.itemTblHeader}>
               {/* br br br or marginTop css here */}
            </View>
          
            <View style={styles.tableItems}>
                <View>
                 	<Text style={styles.header1}>Item</Text>
                </View>
                <View>
                 	<Text style={styles.header2}>Qty</Text>
                 </View>
            </View>
          
           {/* use .map here */}

           {items.map((item=>{
             return(<View style={styles.tableItems}>
              <View>
                 <Text style={styles.item1}>{item.item_name || ""}</Text>
              </View>
              <View style={styles.rightAlign}>
                 <Text style={styles.item2}>{item.qty || ""}</Text>
               </View>
          </View>)
           }))}
           

 		<View style={styles.box}>
              <View style={styles.leftPart}>
                <Text style={styles.tblTitle}>Payment Information</Text>
                   <View style={styles.innerBox}>
                      <View style={styles.innerLeftPayment}>
                        	<View style={styles.paymentInfo}>
                              	<View style={styles.innerLeftPart2}>
                                   <Text>Payment Status</Text>
                                </View>
                              <View style={styles.innerRightPart2}>
                                <Text>{soInfo.ispaid}</Text>
                              </View>
                        	</View>
                        
                        {soInfo.paypanda_payments > 0 ? (<>
                          <View style={styles.paymentInfo}>
                              	<View style={styles.innerLeftPart2}>
                                   <Text>Paypanda Payment</Text>
                                </View>
                              <View style={styles.innerRightPart2}>
                                <Text>{numeral(soInfo.paypanda_payments).format('0,0.00')}</Text>
                              </View>
                        	</View></>) : (<></>)}

                          {soInfo.asiapay_payments > 0 ? (<>
                          <View style={styles.paymentInfo}>
                              	<View style={styles.innerLeftPart2}>
                                   <Text>Asiapay Payment</Text>
                                </View>
                              <View style={styles.innerRightPart2}>
                                <Text>{numeral(soInfo.asiapay_payments).format('0,0.00')}</Text>
                              </View>
                        	</View></>) : (<></>)}

                          
                          {soInfo.ipay_payments > 0 ? (<>
                          <View style={styles.paymentInfo}>
                              	<View style={styles.innerLeftPart2}>
                                   <Text>Ipay Payment</Text>
                                </View>
                              <View style={styles.innerRightPart2}>
                                <Text>{numeral(soInfo.ipay_payments).format('0,0.00')}</Text>
                              </View>
                        	</View></>) : (<></>)}
                        
                             <View style={styles.paymentInfo}>
                              	<View style={styles.innerLeftPart2}>
                                   <Text>Total</Text>
                                </View>
                              <View style={styles.innerRightPart2}>
                                <Text>{numeral(soInfo.grand_total).format('0,0.00')}</Text>
                              </View>
                        	</View>
                      </View>
                     
                       <View style={styles.approvedBy}><Text style={styles.approver}>Approved By:</Text></View>
                   </View>
          	  </View>
        </View>
          

          
         <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
        `Page ${pageNumber} / ${totalPages}`
      )} fixed />
        </Page>
      </Document>
       );
  }; 
   